import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      d: "M20 12H8.368c-2.645 0-4.844 1.872-5.287 4.335M20 19H4.79C3.8 19 3 18.216 3 17.25c0-.312.028-.618.081-.915m0 0c-.027.013.02.027-.007.04m.007-.04c3.511-1.696 7.972-.808 7.972 2.665M18.21 5c0 3.866-3.405 7-7.605 7C6.405 12 3 8.866 3 5h15.21Z"
    }, null, -1)
  ])))
}
export default { render: render }